// 商品ページのサムネイルをクリックしたら拡大表示（おちゃのこ純正のライトボックス）も開く（Issue #72）。
//
// もとは 7 店（1 / 9 / 10 / 11 / 14 / 15 / 16）の商品ページの自由記入欄（#product_detail_free_space）に直書きされていた:
//   $('.thumbnail_image_link').on('click', function() {
//     setTimeout(function() { $('.swiper-slide-active a').trigger('click'); }, 10);
//   });
// サムネイルを押すとおちゃのこ純正のスライダー（swiper）がその画像に切り替わり、10ms 後に表示中のスライドの
// リンク（a.gallery_link.zoom_link）を jQuery で trigger して拡大表示を開く、という動き。
//
// ★ jQuery の trigger('click') を使う理由: a.gallery_link の href は画像そのものの URL で、ネイティブの
//   element.click() だと（ライトボックスが preventDefault しない経路で）画像へ遷移してしまう。
//   jQuery の trigger は <a> に対してネイティブの click を呼ばない（jQuery.event.special.click._default）ので、
//   jQuery ハンドラ（ライトボックス）だけが動く。旧実装と同じ。jQuery が無ければ何もしない（旧実装も動かない）
//
// ★ 過渡期（① hook 公開 → ② 田口さんが欄の直書きを消す）に 2 回走らない:
//   旧の直書きがまだページにあれば hook は何もしない。判定はページ内の <script> の本文を見る
//   （.thumbnail_image_link と swiper-slide-active の両方を含むインラインスクリプトがあれば「旧あり」）。
//   swiper のテンプレート <script type="text/template" id="gallery_slider_item_template"> にも
//   .thumbnail_image_link は出てくるが、swiper-slide-active は無いので当たらない。
//   click ハンドラの有無（jQuery._data）で見る案は jQuery の版に依るので採らなかった。

const THUMB_SELECTOR = '.thumbnail_image_link'
const ACTIVE_LINK_SELECTOR = '.swiper-slide-active a'
const DELAY_MS = 10

type JQueryLike = (selector: string) => { trigger(name: string): unknown }

/** インラインの <script> に旧の直書きがあるか（type="text/template" のような非 JS は見ない） */
export function hasOldThumbnailZoom(doc: ParentNode): boolean {
  const scripts = Array.from(doc.querySelectorAll<HTMLScriptElement>('script:not([src])'))
  return scripts.some((s) => {
    const type = (s.getAttribute('type') ?? '').trim().toLowerCase()
    if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return false
    const text = s.textContent ?? ''
    return text.includes(THUMB_SELECTOR) && text.includes('swiper-slide-active')
  })
}

/** サムネイルに click を束ねる。戻り値は束ねた数（0 = サムネイル無し） */
export function bindThumbnailZoom(
  doc: ParentNode,
  jq: JQueryLike,
  setTimer: (fn: () => void, ms: number) => unknown = (fn, ms) => window.setTimeout(fn, ms),
): number {
  const thumbs = doc.querySelectorAll<HTMLElement>(THUMB_SELECTOR)
  thumbs.forEach((el) => {
    el.addEventListener('click', () => {
      setTimer(() => {
        jq(ACTIVE_LINK_SELECTOR).trigger('click')
      }, DELAY_MS)
    })
  })
  return thumbs.length
}

export default function thumbnailZoom(): void {
  const jq = (window as unknown as { jQuery?: JQueryLike }).jQuery
  if (typeof jq !== 'function') return
  if (hasOldThumbnailZoom(document)) return // 過渡期: 旧の直書きに任せる
  bindThumbnailZoom(document, jq)
}
